export enum ProfileType {
  Company = "Company",
  Provider = "Provider",
  Resale = "Resale",
  Customer = "Customer"
}
